var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.136,
    height: 36.099,
    viewBox: "0 0 27.136 36.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(-922.114 -1380.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M939.257,1398.445a2.86,2.86,0,0,0,1.093,2.249l1.63,1.28a13.92,13.92,0,0,1,4.817,7.678l.554,2.377a1.553,1.553,0,0,0,.929,1.088h0a1.554,1.554,0,0,1,.97,1.44v1.194a.656.656,0,0,1-.656.656H922.769a.655.655,0,0,1-.655-.656v-1.194a1.554,1.554,0,0,1,.969-1.44h0a1.557,1.557,0,0,0,.93-1.088l.553-2.377a13.916,13.916,0,0,1,4.818-7.678l1.629-1.28a2.858,2.858,0,0,0,1.094-2.249v-.175a2.858,2.858,0,0,0-1.094-2.249l-1.629-1.28a13.916,13.916,0,0,1-4.818-7.678l-.553-2.377a1.557,1.557,0,0,0-.93-1.088h0a1.555,1.555,0,0,1-.969-1.44v-1.194a.656.656,0,0,1,.655-.656h25.825a.656.656,0,0,1,.656.656v1.194a1.555,1.555,0,0,1-.97,1.44h0a1.553,1.553,0,0,0-.929,1.088l-.554,2.377a13.92,13.92,0,0,1-4.817,7.678l-1.63,1.28a2.86,2.86,0,0,0-1.093,2.249Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M935.682,1405.977a1.289,1.289,0,0,1,.712.215l7.9,5.271a.733.733,0,0,1,.326.61h0a.734.734,0,0,1-.734.734H927.473a.734.734,0,0,1-.734-.734h0a.733.733,0,0,1,.326-.61l7.9-5.271a1.29,1.29,0,0,1,.713-.215Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M942.13,1390.873c0,1.073-2.917,3.151-4.1,4.024-1.529,1.124-1.529,2.572-2.346,2.572s-.818-1.448-2.346-2.572c-1.186-.873-4.1-2.951-4.1-4.024h0a.764.764,0,0,1,.764-.764h11.369a.764.764,0,0,1,.764.764Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.7259bff608373d30878ca60b044c450f.svg";
export { ForwardRef as ReactComponent };